<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="系统">
                  <el-select v-model="queryForm.vendorSystemId" filterable clearable style="width:100%">
                    <el-option v-for="item in vendorSystemList" :label="item.vendorSystemName" :value="item.vendorSystemId" :key="item.vendorSystemId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺别名">
                  <el-select v-model="queryForm.vendorAliasId" filterable clearable style="width:100%">
                    <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <el-select v-model="queryForm.vendorId" filterable clearable style="width:100%">
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="订单号">
                  <el-input v-model="queryForm.orderLineNum" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="推送状态">
                  <el-select v-model="queryForm.status" clearable style="width:100%">
                    <el-option label="成功" :value="1"></el-option>
                    <el-option label="失败" :value="-1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="推送时间">
                  <el-date-picker
                    style="width:100%"
                    v-model="daterange"
                    type="daterange"
                    value-format="timestamp"
                    :editable="false"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="失败原因">
                  <el-input v-model="queryForm.failedMsg" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-button type="primary" @click="batchPush" :disabled="selection.length === 0">批量重推</el-button>

    <el-table :data="tableData" @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="systemName" label="系统名称"></el-table-column>
      <el-table-column prop="vendorName" label="店铺名称">
        <template slot-scope="scope">
          {{ scope.row.vendorName }}
          <p>/</p>
          {{ scope.row.vendorNameAlias }}
        </template>
      </el-table-column>
      <el-table-column prop="orderLineNum" label="订单号"></el-table-column>
      <el-table-column label="推送状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">成功</span>
          <span v-if="scope.row.status == -1">失败</span>
        </template>
      </el-table-column>
      <el-table-column prop="pushAt" label="推送时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.pushAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="pushTimes" label="推送次数"></el-table-column>
      <el-table-column prop="failedMsg" label="失败原因"></el-table-column>
      <el-table-column prop="productSourceType" label="商品对接方式"></el-table-column>
      <el-table-column label="调用log">
        <template slot-scope="scope">
          <el-link type="primary" @click="showLog(scope.row)">查看详情</el-link>
        </template>
      </el-table-column>
      <el-table-column label="接口信息">
        <template slot-scope="scope">
          <el-link type="primary" @click="showApi(scope.row)">查看详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="查看详情" :visible.sync="dialogVisible" width="800px">
      <el-table v-loading="loadingOrderList" :data="logTableData" style="width: 100%">
        <el-table-column prop="orderLineNum" label="订单号"></el-table-column>
        <el-table-column prop="pushAt" label="推送时间">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.pushAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="失败原因"></el-table-column>
        <el-table-column label="推送状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">成功</span>
            <span v-if="scope.row.status == -1">失败</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.traceId" @click="showData(scope.row)">original data</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="推送结果" :visible.sync="dialogVisible2" width="500px">
      <p>{{ traceData }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="查看详情" :visible.sync="dialogVisible3" width="1100px">
      <!-- <div v-loading="loadingOriginData" style="min-height: 50px">
        <p v-for="(value, key) in originData" :key="key">{{key}}: {{value}}</p>
      </div> -->
      <vue-json-pretty v-if="originData" :data="originData" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import {
  getBoutiqueOrderPushList,
  getBoutiqueOrderPushLog,
  pushBoutiqueOrder,
  getOrgData,
  getVendorConfig,
  getVendorSystemList,
  pushBoutiqueOrderV2,
  postVendorConfig,
} from "../../api/trace";

import { getVendorsByVendorNameRF } from './email/api';
import utils from '@/utils/util';

export default {
  data() {
    return {
      loading: false,
      daterange: [],
      queryForm: {
        vendorSystemId: null,
        vendorAliasId: null,
        vendorId: null,
        orderLineNum: null,
        status: null,
        failedMsg: null,
        pageNo: 1,
        pageSize: 25,
      },
      vendorList: [],
      vendorSystemList: [],
      stockLocationList: [],
      tableData: [],
      total: 0,
      selection: [],
      dialogVisible: false,
      loadingOrderList: false,
      logTableData: [],
      dialogVisible2: false,
      traceData: '',
      dialogVisible3: false,
      originData: {},
      loadingOriginData: false,
    };
  },
  components: {
    VueJsonPretty,
  },
  mounted() {
    getVendorSystemList().then(res => {
      if (res.data && res.data.data) {
        this.vendorSystemList = res.data.data;
      }
    });
    getVendorsByVendorNameRF().then(res => {
      this.vendorList = res.data;
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorSystemId = null;
      this.queryForm.vendorAliasId = null;
      this.queryForm.vendorId = null;
      this.queryForm.orderLineNum = null;
      this.queryForm.status = null;
      this.queryForm.failedMsg = null;
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getBoutiqueOrderPushList({
        ...this.queryForm,
        vendorId: this.queryForm.vendorAliasId || this.queryForm.vendorId,
        startTime: this.daterange[0] ? this.daterange[0] : null,
        endTime: this.daterange[1] ? this.daterange[1] : null,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    batchPush() {
      let orderInfoList =this.selection.map(item=>{
        return {
          orderLineNum:item.orderLineNum,
          boutiqueOrderNo:item.boutiqueOrderNo,
          vendorId:item.vendorId
        }
      });
      pushBoutiqueOrderV2({
        orderInfoList
      }).then(res => {
        if (res.data && res.data.success) {
          const flag = res.data.data.every(item => item.result);
          if (flag) {
            this.$message.success('推送成功');
            this.getTableData();
          } else {
            let str = '';
            res.data.data.forEach(item => {
              str += '<p>订单号：' + item.orderLineNum + ', ' + (item.result ? '推送成功' : '<span class="red">推送失败</span>') + '</p>';
            })
            this.$alert(str, '推送结果', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              callback: () => {
                this.getTableData();
              }
            });
          }
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
    showLog(row) {
      this.dialogVisible = true;
      this.loadingOrderList = true;
      getBoutiqueOrderPushLog({ orderLineNum: row.orderLineNum }).then(res => {
        if (res.data && res.data.success) {
          this.logTableData = res.data.data;
        }
        this.loadingOrderList = false;
      });
    },
    showApi(row) {
      let {boutiqueOrderNo,vendorId} = row;
      this.dialogVisible3 = true;
      this.loadingOriginData = true;
      postVendorConfig({
        boutiqueOrderNo,
        vendorId
      }).then(res => {
      console.error(res,'rrrr')
        if (res.data && res.data.success) {
          this.originData = res.data.data?JSON.parse(res.data.data || null):'' ;
        }
        this.loadingOriginData = false;
      })
    },
    showData(row) {
      getOrgData(row.traceId).then(res => {
        if (res.data && res.data.data) {
          this.traceData = JSON.stringify(res.data.data);
          this.dialogVisible2 = true;
        }
      })
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #DCDFE6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409EFF;
  }
}
.vendor-name {
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow:hidden;
}
</style>
